import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

/** ModelMotive has local projects, not PicPlayer's server-side account routes. */
export function ProfileMenu({ onHome, onAbout }: { onHome: () => void; onAbout: () => void }): React.JSX.Element {
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>
        <button type="button" className="profile-button" aria-label="User profile" title="User profile">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true">
            <circle cx="12" cy="8" r="3.5" /><path d="M5 20v-2a7 7 0 0 1 14 0v2" />
          </svg>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className="dropdown-content profile-dropdown" align="end" sideOffset={6} collisionPadding={8}>
          <div className="profile-summary"><strong>Local profile</strong><span>Models saved on this device.<br />No sign-in is required.</span></div>
          <DropdownMenu.Separator className="dropdown-separator" />
          <DropdownMenu.Item className="network-item" onSelect={onHome}>Project home</DropdownMenu.Item>
          <DropdownMenu.Item className="network-item" onSelect={onAbout}>About &amp; licences</DropdownMenu.Item>
          <DropdownMenu.Separator className="dropdown-separator" />
          <DropdownMenu.Item asChild><a className="network-item" href="./privacy.html" target="_blank" rel="noopener noreferrer">Privacy &amp; advertising</a></DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
